import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIVD as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIVD = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const d1Field = () => {
    const propertyName = pn<AprResponseModel>("d1");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.d1}{" "}
        {formatPercentTotal(props.data?.d1, props.data?.totalParticipantsD6)}
      </DataDisplay>
    );
  };

  const d2Field = () => {
    const propertyName = pn<AprResponseModel>("d2");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.d2}{" "}
        {formatPercentTotal(props.data?.d2, props.data?.totalParticipantsD6)}
      </DataDisplay>
    );
  };

  const d3Field = () => {
    const propertyName = pn<AprResponseModel>("d3");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.d3} {formatPercentTotal(props.data?.d3, props.data?.totalParticipantsD6)}
      </DataDisplay>
    );
  };

  const d4Field = () => {
    const propertyName = pn<AprResponseModel>("d4");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.d4} {formatPercentTotal(props.data?.d4, props.data?.totalParticipantsD6)}
      </DataDisplay>
    );
  };

  const d5Field = () => {
    const propertyName = pn<AprResponseModel>("d5");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.d5} {formatPercentTotal(props.data?.d5, props.data?.totalParticipantsD6)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipantsD6");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipantsD6}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Postsecondary Education Enrollment</Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.d1 != null && (
                <Grid item xs={12}>
                  {d1Field()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.d2 != null && (
                <Grid item xs={12}>
                  {d2Field()}
                </Grid>
              )}

              {props.data?.d3 != null && (
                <Grid item xs={12}>
                  {d3Field()}
                </Grid>
              )}

              {props.data?.d4 != null && (
                <Grid item xs={12}>
                  {d4Field()}
                </Grid>
              )}
              {props.data?.d5 != null && (
                <Grid item xs={12}>
                  {d5Field()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

        </Grid>
      </Stack>
    </Card>
  );
};
